import React, { Component } from "react";
import {
  View,
  StyleSheet,
  TouchableNativeFeedback,
  Linking,
  PixelRatio,
  Dimensions,
} from "react-native";
import { connect } from "react-redux";
import Cross from "@components/RaiseTicket/Cross";
import Landing from "@components/RaiseTicket/Landing";
import Ticket from "@components/RaiseTicket/Ticket";
import Button from "@components/Button";
import analytics from "@services/analytics";
import Text from "@components/AppText";
import { colors } from "@constants/theme";
import { DISCARDED_SCREEN } from "../../constants/analyticsEventsCT";
import CustomTextInput from "./CustomTextInput";
import CityMallLongLogo from "../../assets/svg/CityMallLongLogo";

const { width, height } = Dimensions.get("window");
const scale = width / 360;

function normalize(size) {
  const newSize = size * scale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
}

class Rejected extends Component {
  static navigationOptions = {
    headerShown: false,
  };

  constructor() {
    super();
    this.navigateToRaiseTicketScreen =
      this.navigateToRaiseTicketScreen.bind(this);
  }

  componentDidMount() {
    analytics.trackEvent(DISCARDED_SCREEN.CL_DISCARDED);
  }

  navigateToRaiseTicketScreen() {
    this.props.navigation.navigate("RaiseTicket");
  }

  render() {
    return (
      <View style={styles.topContainer}>
        <View
          style={{
            padding: 15,
          }}
        >
          <CityMallLongLogo height={30} width={114} />
        </View>
        <View style={styles.container}>
          <Ticket
            height={normalize(160)}
            width={normalize(180)}
            style={{ marginBottom: normalize(20) }}
          />
          <View>
            <View style={styles.headingBox}>
              <Text
                numOfLines={2}
                bold
                style={{
                  fontSize: normalize(24),
                  lineHeight: normalize(33),
                  textAlign: "center",
                  color: colors.mediumBlack,
                }}
              >
                माफ़ कीजिये !
              </Text>
            </View>
            <View style={styles.contentBox}>
              <Text
                numOfLines={2}
                style={{
                  fontSize: normalize(19),
                  lineHeight: normalize(28),
                  textAlign: "center",
                  color: colors.lightBlack,
                }}
              >
                आपको सिटीमॉल से निष्काषित कर दिया गया है ।{" "}
              </Text>
            </View>
          </View>
        </View>

        <Button
          btnText="टिकट रेज करें"
          buttonFontType="bold"
          fontSize={normalize(20)}
          buttonWidth={width * 0.88}
          height={normalize(53)}
          borderRadius={10}
          onPress={this.navigateToRaiseTicketScreen}
          containerStyle={{
            alignSelf: "center",
            marginVertical: normalize(20),
          }}
        />
      </View>
    );
  }
}

export default connect()(Rejected);

const styles = StyleSheet.create({
  topContainer: { flex: 1 },
  container: {
    alignItems: "center",
    marginTop: height * 0.1,
    // flex: 1,
  },
  headingBox: { width: width * 0.83, marginVertical: normalize(10) },
  contentBox: { width: width * 0.83, marginVertical: normalize(10) },
});
